import { useIsInDateRange } from '../useIsInDateRange/useIsInDateRange';

const promoConfigs = {
  ostern2025: {
    startDate: '2025-04-07T00:00:00+02:00',
    endDate: '2025-04-21T23:59:59+02:00',
  },
};

export const useIsPromoActive = (promoKey: keyof typeof promoConfigs) => {
  const { startDate, endDate } = promoConfigs[promoKey];

  return useIsInDateRange(startDate, endDate);
};
